// extracted by mini-css-extract-plugin
module.exports = {"rfiDetails":"rfiDetails_rfiDetails__3dTaW","listItems":"rfiDetails_listItems__1ZK2X","textArea":"rfiDetails_textArea__3fAbO","titleLable":"rfiDetails_titleLable__37tb1"};